import React, { useEffect } from 'react';
import { IconButton } from '../core/IconButton.jsx';

/** Modal dialog: warm scrim, 24px-radius card, Esc / overlay click to close. */
export function Dialog({ open = false, title, onClose, footer, width, children, className = '' }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape' && onClose) onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="bjl-dialog-overlay" onClick={(e) => { if (e.target === e.currentTarget && onClose) onClose(); }}>
      <div className={`bjl-dialog ${className}`} style={width ? { width } : undefined} role="dialog" aria-modal="true">
        {onClose ? <IconButton className="bjl-dialog__close" icon="close" label="关闭" onClick={onClose} /> : null}
        {title ? <h3 className="bjl-dialog__title">{title}</h3> : null}
        {children}
        {footer ? <div className="bjl-dialog__footer">{footer}</div> : null}
      </div>
    </div>
  );
}
